import React, { useMemo } from "react";
import { Navigate, useLocation, useParams } from "react-router-dom";
import { DOC_TYPES } from "../../util/Constants";
import { PATH } from "../../routes/routes";

import { clientFormBonDeComandaConfig } from "./docTypes/clientFormBonDeComanda.config";
import { clientFormFisaServiceConfig} from "./docTypes/clientFormFisaService.config";
import ServiceDocsManager from "./components/ServiceDocsManager";

export default function ServiceDocsHome() {
  const { companyId } = useParams();
  const location = useLocation();

  const registry = useMemo(() => {
    const list = [clientFormBonDeComandaConfig({ companyId }), clientFormFisaServiceConfig({ companyId })];

    return list.reduce((acc, cfg) => {
      acc[cfg.value] = cfg;
      return acc;
    }, {});
  }, [companyId]);

  
  const selectedValue =
    Object.values(registry).find((cfg) => cfg.path === location.pathname)?.value ?? DOC_TYPES.BON;

  const selectedDocType = {
    label: registry[selectedValue]?.label || "Bon de comandă",
    value: selectedValue,
  };

 
  const isBaseRoute = location.pathname === PATH.SERVICE(companyId);
  if (isBaseRoute) {
    return <Navigate to={PATH.SERVICE_BONURI(companyId)} replace />;
  }

  return (
    <ServiceDocsManager companyId={companyId} registry={registry} defaultDocType={selectedDocType} />
  );
}
